import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loading from "../Components/Loading/Loading";
import EmailVerification from "../Components/EmailVerification/EmailVerification";
import EmailVerificationLink from "../Components/EmailVerification/EmailVerificationLink";
const GetInTouch = React.lazy(() =>
  import("../Components/Public/GetInTouch/GetInTouch")
);

const EmailRoutes = (props) => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/*" exact element={<EmailVerification {...props} />} />{" "}
        <Route path="/get-in-touch" element={<GetInTouch {...props} />} />
        <Route
          path="/verification/:id"
          exact
          element={<EmailVerificationLink {...props} />}
        />{" "}
      </Routes>
    </Suspense>
  );
};

export default EmailRoutes;
